import React, { useEffect, useState } from "react";
import "./Common.css";
import { useNavigate } from "react-router-dom";
import LoginPopup from "./LoginPopup";

function HeroSection() {
  const navigate = useNavigate();
  const allImages = [
    "/Images/Gallary1.svg",
    "/Images/Gallary2.svg",
    "/Images/Gallary3.svg",
    "/Images/Gallary4.svg",
    "/Images/Gallary5.svg",
    "/Images/Images23.svg",
    "/Images/Image114.jpg",
    "/Images/Image115.jpg",
    "/Images/Image116.jpeg",
    "/Images/Image117.jpeg",
  ];

  const [topIndex, setTopIndex] = useState(0);
  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setTopIndex((prev) => (prev + 1) % allImages.length);
    }, 3000);

    return () => {
      clearInterval(timer);
    };
  }, [allImages.length]);

  return (
    <section className="hero-section">
      <div className="container">
        <div className="row align-items-center">
          {/* LEFT SIDE */}
          <div className="col-lg-4">
            <div className="d-flex">
              {/* <img
                src="/images/Wada13.svg"
                alt="Anemia Mukt Bharat"
                className="hero-logo mx-2"
              /> */}
              <h1 className="hero-title">
                Anemia Mukt <br />
                Bharat Abhiyaan
              </h1>
            </div>
            <div className="hero-tag">Building a Healthier India</div>

            <div className="logo-row">
              <div className="small-logo">
                <img src="/Images/Jannani.svg" alt="" />
                <span>JANANI</span>
              </div>

              <div className="small-logo">
                <img src="/Images/RBSK.svg" alt="" />
                <span>RBSK</span>
              </div>

              <div className="small-logo">
                <img src="/Images/Uwinrb.svg" alt="" />
                <span>U-WIN</span>
              </div>
            </div>

            <div className="hero-buttons">
              <button
                className="btn btn-success"
                onClick={() => setShowLogin(true)}
              >
                Explore Dashboard →
              </button>

              <button className="btn learn-btn" onClick={() => {
                window.location.href = "https://ambabhiyaan.mohfw.gov.in/AMB/";
              }}>Login</button>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-8">
            <div className="hero-gallery">
              <div className="gallery-grid">
                {/* Large Image */}
                <div className="big-image">
                  <img
                    src={allImages[topIndex % allImages.length]}
                    alt=""
                  />

                  {/* <div className="overlay-icon">
                  <img src="/images/Middle1.svg" alt="" />
                </div> */}
                </div>

                {/* Rotating Images */}
                <div className="small-image">
                  <img src={allImages[(topIndex + 1) % allImages.length]} alt="" />
                </div>

                <div className="small-image">
                  <img src={allImages[(topIndex + 2) % allImages.length]} alt="" />
                </div>

                <div className="small-image">
                  <img src={allImages[(topIndex + 3) % allImages.length]} alt="" />
                </div>

                <div className="small-image">
                  <img src={allImages[(topIndex + 4) % allImages.length]} alt="" />
                </div>

                {/* Static Green Card */}
                <div className="green-card">
                  <div className="card-content">
                    <img src="/Images/Middle1.svg" alt="" />
                    <h6>IFA SUPPLEMENTATION</h6>
                  </div>
                </div>

                {/* Middle Animated Image */}
                <div className="middle-slider">
                  <img src={allImages[(topIndex + 5) % allImages.length]} alt="" />
                </div>

                {/* Static Purple Card */}
                <div className="purple-card">
                  <div className="card-content">
                    <img src="/Images/Middle2.svg" alt="" />
                    <h6>Jan Bhagidari</h6>
                    <p>Community outreach</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LoginPopup show={showLogin} handleClose={() => setShowLogin(false)} />
    </section>
  );
}

export default HeroSection;
